// src/pages/ConferirDocumento/hooks/useConferencias.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useConferencias = () => {
  const [conferencias, setConferencias] = useState([]);
  const [loading, setLoading] = useState(false);

  const carregarConferencias = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/conferir-documento/listar');
      if (response.data.success) {
        setConferencias(response.data.data);
      }
    } catch (error) {
      console.error('Erro ao carregar conferências:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarConferencias();
  }, []);

  return {
    conferencias,
    loading,
    recarregar: carregarConferencias
  };
};